import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63437102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "pl-20 pr-20" }
const _hoisted_3 = { class: "pl-20 pr-20" }
const _hoisted_4 = { class: "pl-20 pr-20" }

import Api from "@/http/modules";
import FixedAssetsOperator from '@/views/ViewsComponents/officeAssets/FixedAssetsOperator.vue'
import {computed, reactive, ref} from "vue";
import {type_consumables, type_fixed, type_intangible,fixed_asset_change_type_rk} from './ViewsComponents/officeAssets/OfficeAssetUtils'
import IntangibleAssetsOperator from "@/views/ViewsComponents/officeAssets/IntangibleAssetsOperator.vue";
import ConsumablesAssetsOperator from "@/views/ViewsComponents/officeAssets/ConsumablesAssetsOperator.vue";
import FixedAssetChange from "@/views/ViewsComponents/officeAssets/FixedAssetChange.vue";
import IntangibleAssetChange from "@/views/ViewsComponents/officeAssets/IntangibleAssetChange.vue";
import ConsumablesAssetChange from "@/views/ViewsComponents/officeAssets/ConsumablesAssetChange.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 获取所有公司
  'GET/company': companyApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  'GET/office/asset/category/{type}/valid_list': validCategoriesApi,
  'GET/users': usersListApi,
  "POST/office/asset/register": registerApi,
  "POST/office/asset/change_record/{id}": changeRecordDetailApi
} = Api
const activeTable = ref(type_fixed)
const options = reactive<{ orgs: any[], companies: any[], categories: any[] }>({
  orgs: [],
  companies: [],
  categories: [],
})
const onOperatorDialogShow = () => {
  if (options.companies.length < 1) {
    companyApi().then((r: any) => {
      options.companies = r;
    })
  }
  if (options.orgs.length < 1) {
    organizationsApi().then((r: any) => {
      options.orgs = r;
    })
  }
  if (options.categories.length < 1) {
    validCategoriesApi({type: "all"}).then((r: any) => {
      options.categories = r
    })
  }
}
let fixedCategories = computed(() => {
  return options.categories.filter(i => i.type == type_fixed)
})
let intangibleCategories = computed(() => {
  return options.categories.filter(i => i.type == type_intangible)
})
let consumablesCategories = computed(() => {
  return options.categories.filter(i => i.type == type_consumables)
})
const changeRecordDetailDialogItems = {
  [type_fixed]: {
    title: "固定资产变动明细",
    assetNo: "资产编号",
    assetName: "资产名称",
    categoryName: "资产类别",
  },
  [type_intangible]: {
    title: "无形资产变动明细",
    assetNo: "无形资产编号",
    assetName: "无形资产名称",
    categoryName: "类别",
  },
  [type_consumables]: {
    title: "耗材变动明细",
    assetNo: "耗材编号",
    assetName: "耗材名称",
    categoryName: "耗材类别",
  }
}
const changeRecordDetailDialogInfo = reactive<{
  isShow: boolean,
  record: any,
  type: string,
  changeType: string,
  loading: boolean,
  list: any[]
}>({
  isShow: false,
  record: null,
  loading: false,
  list: [],
  type: type_fixed,
  changeType: '',
})


const showChangeRecordDetailDialog = (obj: any) => {
  const {record, type,changeType} = obj
  changeRecordDetailDialogInfo.record = record
  changeRecordDetailDialogInfo.list = []
  changeRecordDetailDialogInfo.loading = true
  changeRecordDetailDialogInfo.isShow = true
  changeRecordDetailDialogInfo.type = type
  changeRecordDetailDialogInfo.changeType = changeType

  changeRecordDetailApi({id: record.id}).then((r: any) => {
    changeRecordDetailDialogInfo.loading = false
    changeRecordDetailDialogInfo.list = r
  }).catch(() => {
    changeRecordDetailDialogInfo.loading = false
  })
}
const refresh = ref<number>(0)
const callback = (obj: { command: string, data: any }) => {
  refresh.value += 1;
}
const fixSearchObj=ref<{
  orgId: null | number,
  companyId: null | number,
  date: string[],
}>({
  orgId: null,
  companyId: null,
  date: []
})
const  fixSearchObjChange=(i:any)=>{
  // console.log("fixSearchObjChange",i)
  fixSearchObj.value=i
}
const intangibleSearchObj=ref<{
  orgId: null | number,
  companyId: null | number,
  date: string[],
}>({
  orgId: null,
  companyId: null,
  date: []
})
const  intangibleSearchObjChange=(i:any)=>{
  // console.log("intangibleSearchObjChange",i)
  intangibleSearchObj.value=i
}
const consumablesSearchObj=ref<{
  orgId: null | number,
  companyId: null | number,
  date: string[],
}>({
  orgId: null,
  companyId: null,
  date: []
})
const  consumablesSearchObjChange=(i:any)=>{
  consumablesSearchObj.value=i
}


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      class: "tabs type-tabs",
      modelValue: activeTable.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTable).value = $event)),
      type: "border-card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "固定资产变动",
          name: _unref(type_fixed)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(FixedAssetsOperator, {
                "register-api": _unref(registerApi),
                "users-list-api": _unref(usersListApi),
                "category-list": _unref(fixedCategories),
                "company-list": _unref(options).companies,
                "org-list": _unref(options).orgs,
                onSearch: fixSearchObjChange,
                onDialogShow: onOperatorDialogShow,
                callback: callback
              }, null, 8, ["register-api", "users-list-api", "category-list", "company-list", "org-list"]),
              _createVNode(FixedAssetChange, {
                "change-count": refresh.value,
                "search-obj": fixSearchObj.value,
                onChangeRecordDetail: showChangeRecordDetailDialog
              }, null, 8, ["change-count", "search-obj"])
            ])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "无形资产变动",
          name: _unref(type_intangible),
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(IntangibleAssetsOperator, {
                "category-list": _unref(intangibleCategories),
                "company-list": _unref(options).companies,
                "org-list": _unref(options).orgs,
                "register-api": _unref(registerApi),
                "users-list-api": _unref(usersListApi),
                onDialogShow: onOperatorDialogShow,
                callback: callback,
                onSearch: intangibleSearchObjChange
              }, null, 8, ["category-list", "company-list", "org-list", "register-api", "users-list-api"]),
              _createVNode(IntangibleAssetChange, {
                "change-count": refresh.value,
                "search-obj": intangibleSearchObj.value,
                onChangeRecordDetail: showChangeRecordDetailDialog
              }, null, 8, ["change-count", "search-obj"])
            ])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "耗材变动",
          name: _unref(type_consumables),
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(ConsumablesAssetsOperator, {
                "category-list": _unref(consumablesCategories),
                "company-list": _unref(options).companies,
                "org-list": _unref(options).orgs,
                "register-api": _unref(registerApi),
                "users-list-api": _unref(usersListApi),
                onDialogShow: onOperatorDialogShow,
                onSearch: consumablesSearchObjChange,
                callback: callback
              }, null, 8, ["category-list", "company-list", "org-list", "register-api", "users-list-api"]),
              _createVNode(ConsumablesAssetChange, {
                "change-count": refresh.value,
                "search-obj": consumablesSearchObj.value,
                onChangeRecordDetail: showChangeRecordDetailDialog
              }, null, 8, ["change-count", "search-obj"])
            ])
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "changeRecordDetailDialog",
      modelValue: _unref(changeRecordDetailDialogInfo).isShow,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(changeRecordDetailDialogInfo).isShow) = $event)),
      draggable: "",
      width: "1200px"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(changeRecordDetailDialogItems[_unref(changeRecordDetailDialogInfo).type].title), 1)
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "changeRecordDetailTbEle",
          border: "",
          class: "mt-10",
          data: _unref(changeRecordDetailDialogInfo).list,
          "row-key": "id",
          "max-height": '520px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              type: "index",
              width: "55",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "所属团队",
              prop: "orgName",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "所属公司",
              prop: "companyName",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: changeRecordDetailDialogItems[_unref(changeRecordDetailDialogInfo).type].assetNo,
              prop: "assetNo",
              "min-width": "220",
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: changeRecordDetailDialogItems[_unref(changeRecordDetailDialogInfo).type].assetName,
              prop: "assetName",
              "min-width": "120",
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            (_unref(changeRecordDetailDialogInfo).type===_unref(type_fixed))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "规格型号",
                  prop: "spec",
                  "min-width": "100",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true),
            (_unref(changeRecordDetailDialogInfo).type===_unref(type_fixed))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  label: "电脑设备ID",
                  prop: "deviceId",
                  "min-width": "120",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              label: changeRecordDetailDialogItems[_unref(changeRecordDetailDialogInfo).type].categoryName,
              prop: "categoryName",
              "min-width": "120",
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            (_unref(changeRecordDetailDialogInfo).type===_unref(type_intangible))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 2,
                  label: "失效日期",
                  prop: "expireDate",
                  "min-width": "180"
                }))
              : _createCommentVNode("", true),
            (_unref(changeRecordDetailDialogInfo).type!==_unref(type_intangible))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 3,
                  label: "单位",
                  prop: "unit",
                  "min-width": "100",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true),
            (_unref(changeRecordDetailDialogInfo).type===_unref(type_fixed))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 4,
                  label: "数量",
                  prop: "count",
                  "min-width": "100",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true),
            (_unref(changeRecordDetailDialogInfo).type===_unref(type_consumables)&&_unref(changeRecordDetailDialogInfo).changeType===_unref(fixed_asset_change_type_rk))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 5,
                  label: "数量",
                  prop: "initCount",
                  "min-width": "100",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true),
            (_unref(changeRecordDetailDialogInfo).type===_unref(type_consumables)&&_unref(changeRecordDetailDialogInfo).changeType!==_unref(fixed_asset_change_type_rk))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 6,
                  label: "领用数量",
                  prop: "useCount",
                  "min-width": "120",
                  "show-overflow-tooltip": ""
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(changeRecordDetailDialogInfo).loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})